<template>
  <div class="template">
    <div class="header">
      <div class="left">打印设置</div>
      <div class="right">安装客户端，打印更顺畅 
        <a target="_blank" :href="khdUrl32">32位</a>
        <a target="_blank" :href="khdUrl64" style="margin-left:10px">64位</a>
      </div>
    </div>  
    <div class="printBox">
      <i class="el-icon-printer printerIcon"></i><span style="padding-right:20px">默认打印机：<b>{{printName}}</b></span>
      选择默认打印机：
      <el-select v-model="printName" placeholder="请选择" @change="setDefaultPrinter" @focus="getPrintlist" size="mini">
        <el-option
          v-for="item in printList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <i class="el-icon-question" style="color:#2ea2fc;cursor: pointer;padding-left:10px" @click="goerrorTip"></i>
    </div>
    <div class="templateImg">
      <ul class="list">
        <li
          v-for="(el, i) in imgArr"
          :key="i"
        >
          <div class="l_item" :class="activeInde == i ? 'activeClass' : ''">
            <p class="name">{{ el.template_name }}</p>
            <img class="hoverImg" :src="el.template_image" alt />
            <div class="modal">
              <div>
                <el-button
                  size="medium"
                  type="primary"
                  @click="setTemplate(i, el)"
                  v-if="el.template_status != 1"
                >设为模板</el-button>
                <el-button size="medium" type="primary" @click="testPrint(el)">测试打印</el-button>
              </div>
            </div>   
            <!-- <ul class="preview-list">
              <img :src="el.template_image" alt />
            </ul> -->
            <p class="tangle" v-if="el.is_default == 1">
              <span>已选</span>
            </p>                   
          </div>
          <div class="set-offset">
            <h4>打印偏移设置</h4>
            <p class="row">
              <span
                @click="clickLeftOffset(index,i)"
                v-for="(item,index) in leftOffset"
                :class="el.offset.zyactive == index?'activeClass':''"
                :key="index"
              >{{item}}</span>
              <el-input-number
                size="mini"
                :min="min"
                :max="max"
                v-model="el.offset.offset_x"
                placeholder="偏移数值"
                @change="(val)=>{leftInput(val,i)}"
              ></el-input-number>
            </p>
            <p class="row">
              <span
                @click="clickTopOffset(index,i)"
                v-for="(item,index) in topOffset"
                :class="el.offset.sxactive ==index?'activeClass':''"
                :key="index"
              >{{item}}</span>
              <el-input-number
                size="mini"
                :min="min2"
                :max="max2"
                v-model="el.offset.offset_y"
                placeholder="偏移数值"
                @change="(val)=>{topInput(val,i)}"
              ></el-input-number>
            </p>
          </div>
        </li>
        <li class="printTip">
          <div>1.为了更好的兼容打印插件，请使用<b>谷歌浏览器</b>。</div>
          <div>2.打印插件安装地址<el-link type="primary" :href="downloadUrl32">点击下载32位</el-link>，
            <el-link type="primary" :href="downloadUrl64">点击下载64位</el-link>，安装成功后请刷新本页面或重启浏览器。
          </div>
          <div>3.请在上方选择您要使用的“默认打印机”，方可正常打印。</div>
          <div>4.可通过设置打印偏移量来控制打印内容在面单纸的位置。</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
var LODOP
import util from '@/util/util';
import { needCLodop,getLodop } from "@/util/LodopFuncs";
import setTemp from "../api/setTemplate";
import { PrintWaiting} from "../util/ptintTool";
export default {
  name:'setTemplate',
  data() {
    return {
      activeInde: -1,
      imgArr: [],
      printStatus: 0, //打印状态
      shadowShow: false, //遮罩显示与否
      count: 1, //打印份数
      leftOffset: ["向左", "向右"],
      topOffset: ["向上", "向下"],
      min: -200,
      max: 200,
      min2: -200,
      max2: 200,
      offsetList:[],
      offsetKey:[],
      printName:'',
      printList:[],
      downloadUrl32:'',
      downloadUrl64:'',
      khdUrl32:'',
      khdUrl64:'',
    };
  },
  created() {},
  mounted(){
   this.printName = util.getCookie("defult_print") || '';
   this.getTemplate();
   setTimeout(() => {
    //  console.log(util.getJsonValues(this.$store.state.commondict,"lodopurl"),'下载地址');
     this.downloadUrl32 = util.getJsonValues(this.$store.state.commondict,'lodopurl32')||'http://www.lodop.net/demolist/CLodop_Setup_for_Win32NT.zip'
     this.downloadUrl64 = util.getJsonValues(this.$store.state.commondict,'lodopurl64')||'http://lodop.net/download/CLodop_Setup_for_Win64NT_4.158EN.zip'
     const pcUrlconfig = util.getJsonValues(this.$store.state.commondict,'pcUrlconfig')
     if(pcUrlconfig){
        this.khdUrl32 = JSON.parse(pcUrlconfig).ysbClienturl32
        this.khdUrl64 = JSON.parse(pcUrlconfig).ysbClienturl64
        console.log(this.khdUrl32,this.khdUrl64)
     }    
   }, 500);
  }, 
  methods: {
    goerrorTip(){
      const Obstruct = util.getJsonValues(this.$store.state.commondict,'printObstruct')
      if(Obstruct){
        const Item = JSON.parse(Obstruct).noPrinter
        window.open(Item)
      }     
    },
    //获取打印机列表
    getPrintlist(){
      try {
        LODOP = getCLodop();
      } catch (err) {}
          const num = LODOP.GET_PRINTER_COUNT();
          let printArr = [];
          for(let i=0;i<num;i++){
            printArr.push(LODOP.GET_PRINTER_NAME(i)); 
          }    
          this.printList = printArr;   
      // }
    },
    //设置默认打印机
    setDefaultPrinter(val){
      if(val){
        this.printName = val;
        setTemp.submitPrintName(this,val).then(res=>{
          if(res.success){
            util.setCookie("defult_print",val); 
          }
        })      
      }
    },
    // //获取选择的默认打印机
    // getDefaultPrinter(){
    //   LODOP=getLodop(this);
    //   return LODOP.GET_PRINTER_NAME(-1)
    // },
    //左右偏移量设置
    clickLeftOffset(index,i) {
      let item = this.imgArr[i].offset;        
      item.zyactive = index;
      if (index == 0) {
        this.min = -200;
        this.max = 0;
        if (item.offset_x > 0) {
          item.offset_x = -item.offset_x;
        } else {
        }
      } else {
        this.min = 0;
        this.max = 200;
        if (item.offset_x < 0) {
          item.offset_x = -item.offset_x;
        } else {
        }
      }
      this.imgArr[i].offset = item;
    },
    //设置左右偏移量
    leftInput(value,i) {
      let item = this.imgArr[i].offset; 
      item.offset_x = value;
      if (value > 0) {
        item.zyactive = 1;
        this.min = 0;
        this.max = 200;
      } else if (value < 0) {
        item.zyactive = 0;
        this.min = -200;
        this.max = 0;
      }else{
        item.zyactive = -1;
        this.min = -200;
        this.max = 200;
      }
      this.imgArr[i].offset = item;
      setTemp.setOffset(
        this,
        this.imgArr[i].template_code,
        item
      ).then(res => {
        if (res.success) {
          // this.queryOffset();
        }
      });
    },
    //上下偏移量设置
    clickTopOffset(index,i) {
      let item = this.imgArr[i].offset;        
      item.sxactive = index;
      if (index == 0) {
        this.min2 = -200;
        this.max2 = 0;
        if (item.offset_y > 0) {
          item.offset_y = -item.offset_y;
        } else {
        }
      } else {
        this.min2 = 0;
        this.max2 = 200;
        if (item.offset_y < 0) {
          item.offset_y = -item.offset_y;
        } else {
        }
      }
      this.imgArr[i].offset = item;
    },
    //设置上下偏移量
    topInput(value,i) {
      let item = this.imgArr[i].offset; 
      item.offset_y = value;
      if (value > 0) {
        item.sxactive = 1;
        this.min2 = 0;
        this.max2 = 200;
      } else if (value < 0) {
        item.sxactive = 0;
        this.min2 = -200;
        this.max2 = 0;
      }else{
        item.sxactive = -1;
        this.min2 = -200;
        this.max2 = 200;
      }
      this.imgArr[i].offset = item;
      setTemp.setOffset(
        this,
        this.imgArr[i].template_code,
        item
      ).then(res => {
        if (res.success) {
        }
      });
    },

    //获取模板信息
    getTemplate() {
      setTemp.templateList(this).then(res => {
        const data = res.data;
        this.imgArr = [];
        data.forEach(el => {
          el.offset.sxactive = el.offset.offset_y == 0 ? -1 : (el.offset.offset_y > 0 ? 1 : 0);
          el.offset.zyactive = el.offset.offset_x == 0 ? -1 : (el.offset.offset_x > 0 ? 1 : 0);
          this.imgArr.push(el)
        });
      });
    },
    //设置模板信息
    setTemplate(index, item) {
      this.activeInde = index;
      setTemp.setTemplate(this,item.template_code).then(res => {
        console.log(res);
        if (res.success) {
          this.$message.success('模板设置成功')
          this.getTemplate();
        }
      });
    },
    //测试打印
    testPrint(item) {
      const {lodopStatus,WebSocketstatus,name} = this.$store.state.connetStatus
      if(!lodopStatus || !WebSocketstatus || !name){
        this.$printError(true);
        return
      }
      setTemp.testPrint(this,item.template_code).then(res => {
        this.tempalteData = res.data;
        if (res.success) {
          this.$message.success('打印信息已成功提交至'+util.getCookie("defult_print")+'打印,若打印机长时间不出纸，可以F5刷新浏览器后再次操作')
        }
      });
    },
    //选择默认打印机
    SelectAsDefaultPrinter() {
      // LODOP=getLodop();  
      if (LODOP.CVERSION) {
        LODOP.On_Return=function(TaskID,Value){if(Value>=0) alert("选择成功!"); else alert("选择失败！");};
        LODOP.SELECT_PRINTER();
        return;
      };
      if (LODOP.SELECT_PRINTER()>=0)	alert("选择成功!"); else alert("选择失败！"); }
  }
};
</script>
<style lang="stylus" scoped>
.printerIcon{
  color:#2ea2fc;
  font-size: 16px;
  padding-right: 10px
}
.template {
  min-width: 980px;
  min-height: calc(100vh - 140px);
  padding: 10px 30px;

  .header{
    border-bottom  1px solid #DCDFE6  
    line-height 50px
    display flex
    justify-content: space-between
    .left{
       font-size 16px;
       font-weight bold 
       color #2ea2fc
    }
    .right{
      font-size:14px;
      a{
        cursor: pointer;
        padding: 4px
        color #2ea2fc
        border:1px solid #2ea2fc
        border-radius: 6px
      }
    }
  }
  .printBox{
    padding-left 20px;
    margin-top 20px
    font-size:14px
  }
  .lodopurl{
    padding-left: 20px;
    padding-top:10px;
    font-size: 14px;
    line-height: 20px;
    color: #909399;
  }
  .templateImg {
    display: flex;
    font-size:14px;

    .list {
      display: flex;
      // width: 50%;
      padding: 30px 20px;
      box-sizing: border-box;

      li {
        .l_item{
          min-width: 200px;
          position: relative;
          margin-right: 70px;
          text-align: center;
          .name {
            font-size: 14px;
            color: #000;
            margin-bottom: 10px;
          }

          .hoverImg {
            height: 300px;
            width: 200px;
          }

          .modal {
            display: none;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            text-align: center;
            border-radius: 20px;

            div {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }

            /deep/ .el-button+.el-button {
              margin-left: 0;
              margin-top: 15px;
            }
          }

          &:hover {
            .modal {
              display: block;
            }

            // .preview-list {
            //   display: block;

            //   img {
            //     width: auto;
            //     height: 520px !important;
            //   }
            // }
          }
        }
        // .activeClass {
        //   // border: 1px solid #1c8bf6;
        // }
        .tangle {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 1000;
          width: 0;
          height: 0;
          border-width: 30px;
          border-style: solid;
          border-color: transparent #FFD700 #FFD700 transparent;
          transform: rotate(270deg);
          font-size: 14px;
          border-bottom-right-radius: 20px;

          span {
            position: relative;
            left: 4px;
            top: -4px;
            display: inline-block;
            font-size: 12px;
            color: #fff;
            transform: rotate(45deg);
          }
        }
        .set-offset {
          margin-right: 20px;
          margin-top: 50px;

          h4 {
            margin: 10px 0;
          }

          .row {
            display: flex;
            margin-bottom: 4px;

            span {
              display: inline-block;
              width: 50px;
              height: 25px;
              line-height: 25px;
              margin-right: 10px;
              margin-bottom: 10px;
              font-size: 12px;
              text-align: center;
              border: 1px solid red;
              border-radius: 4px;
              cursor: pointer;
              background-color: #fff;
              border: 1px solid #DCDFE6;
            }

            & span:first-child {
            }

            /deep/.el-input-number--mini {
              width: 120px;
            }

            /deep/.el-input--suffix .el-input__inner {
              padding-right: 18px;
            }

            .activeClass {
              border: 1px solid #3a8ee6;
              background-color: #409eff;
              color: #fff;
            }
          }
        }
      }
    }

    .preview-list {
      display: none;
      position: fixed;
      top: 170px;
      right: 0;
      width: 40%;

      img {
        // width:300px!important;
        // height:500px!important;
      }
    }
  }

  .set {
    display: flex;
    padding: 0 20px;

    .set-offset {
      margin-right: 20px;

      h4 {
        margin: 10px 0;
      }

      .row {
        display: flex;
        margin-bottom: 4px;

        span {
          display: inline-block;
          width: 50px;
          height: 25px;
          line-height: 25px;
          margin-right: 10px;
          margin-bottom: 10px;
          font-size: 12px;
          text-align: center;
          border: 1px solid red;
          border-radius: 4px;
          cursor: pointer;
          background-color: #fff;
          border: 1px solid #DCDFE6;
        }

        & span:first-child {
        }

        /deep/.el-input-number--mini {
          width: 120px;
        }

        /deep/.el-input--suffix .el-input__inner {
          padding-right: 18px;
        }

        .activeClass {
          border: 1px solid #3a8ee6;
          background-color: #409eff;
          color: #fff;
        }
      }
    }
  }
  .printTip{
    padding-top: 100px;
    div{
      padding-bottom: 10px;
      line-height: 20px;
    }
  }
}
</style>